import { ITableField } from '@/shared/Tables/Table'
import Tag from '@/shared/Tags/Tag'
import { IUser, IUserInfo } from '@/pages/Users/users.types.ts'
import userUtils from '@/pages/User/user.utils'

const usersTableFields: ITableField<IUser, keyof IUser | keyof IUserInfo | 'full-name'>[] = [
  {
    key: 'full-name',
    clientSideOrdering: true,
    width: '300px',
    header: 'ФИО',
    getter: (it) => userUtils.getFullName(it.userInfo),
    sortGetter: (it) => userUtils.getFullName(it.userInfo),
  },
  {
    key: 'email',
    clientSideOrdering: true,
    width: '300px',
    header: 'Email',
    getter: (it) => it.email || '-',
    sortGetter: (it) => it.email,
  },
  {
    key: 'phoneNumber',
    clientSideOrdering: true,
    width: '300px',
    header: 'Номер телефона',
    getter: (it) => it.userInfo.phoneNumber || '-',
    sortGetter: (it) => it.email,
  },
  {
    key: 'position',
    clientSideOrdering: true,
    width: '300px',
    header: 'Должность',
    getter: (it) => it.position || '-',
    sortGetter: (it) => it.position,
  },
  {
    key: 'active',
    clientSideOrdering: true,
    width: '200px',
    header: 'Статус',
    getter: (it) => (it.active ? <Tag color="green">Активен</Tag> : <Tag color="red">Деактивирован</Tag>),
    sortGetter: (it) => Number(it.active),
  },
]

export default usersTableFields
